


export const SUCCESS_CODE = '00000'

/** *  */
export const GAME_ID = 'GAME_ID';


export const LIQI_ROUTES = 'LIQI_ROUTES'


export const menu_type_menu = 'menu';

export const menu_type_button = 'button';

export const menu_type_endpoint = 'endpoint';

export type MenuType = typeof menu_type_menu | typeof menu_type_button | typeof menu_type_endpoint


export const MenuTypeMap = {
    [menu_type_menu]:'菜单',
    [menu_type_button]:'按钮',
    [menu_type_endpoint]:'接口',
}


export const ALL_GAME_ID = 0;



export const REQUEST_CHILD_GAME_ID = 'childGameId' ;


export const REQUEST_GAME_ID = 'gameId'


export const CHANNEL_ID = "channelId"


export const NEED_DEAL_PARAMS = [REQUEST_GAME_ID,REQUEST_CHILD_GAME_ID]


export const DATA = 'data';


export const UNITY_GAME_ID = 0;


export const ALL_OPTIONS = {value:UNITY_GAME_ID,label:'通用[0]'}

// 默认全部
export const placeholder_all = '默认'


/** 容器id */
export const LQCONTAINER = 'LQCONTAINER'


export const custom_table_getContainer = () => { return document.getElementById(LQCONTAINER)! }


export const IsNeedGameId = "Is_Need_Game_Id"

export const IsNeedChildChildGameId = "Is_Need_Child_Game_Id"

export const notNeedGameId = "1"

export const notNeedChildGameId = "1"

export const LQ_DEV = "dev";

export const LQ_PROD = "prod";

/** 首页权限ID */
export const MAIN_PAYE_ID = '1'